import { useState } from 'react';

const faq = [
  {
    question: 'Preciso integrar meu ERP?',
    answer:
      'Não. CSV ou Excel exportado do seu sistema é suficiente para o diagnóstico.',
  },
  {
    question: 'Vocês compram por mim?',
    answer:
      'Não. A recomendação é uma decisão assistida — a compra continua sendo sua.',
  },
  {
    question: 'O que acontece com os meus dados?',
    answer:
      'São usados apenas para o seu diagnóstico. Não são compartilhados nem utilizados para outros clientes.',
  },
  {
    question: 'Isso é inteligência artificial?',
    answer:
      'A previsão é feita por modelos estatísticos de série temporal, escolhidos e testados contra o seu histórico real. IA é usada apenas para explicar os resultados em linguagem simples, nunca para inventar números.',
  },
  {
    question: 'Quanto tempo leva?',
    answer: 'Até 30 dias desde o recebimento dos dados.',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="duvidas" className="py-20 md:py-28 bg-white">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block font-sora font-semibold text-emerald-600 text-sm uppercase tracking-widest mb-3">
            Perguntas frequentes
          </span>
          <h2 className="font-sora font-bold text-3xl md:text-4xl text-zinc-900 mb-4">
            Dúvidas comuns
          </h2>
          <p className="font-inter text-zinc-500 max-w-xl mx-auto text-base">
            Respostas diretas sobre o que o diagnóstico é — e o que ele não é.
          </p>
          <div className="w-12 h-1 bg-emerald-500 rounded-full mx-auto mt-5" />
        </div>

        <ul className="space-y-3">
          {faq.map((item, index) => {
            const isOpen = openIndex === index;
            const panelId = `faq-panel-${index}`;
            const buttonId = `faq-button-${index}`;

            return (
              <li
                key={item.question}
                className="bg-white rounded-2xl border border-zinc-200 overflow-hidden"
              >
                <button
                  type="button"
                  id={buttonId}
                  aria-expanded={isOpen}
                  aria-controls={panelId}
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="w-full flex items-center justify-between gap-4 text-left px-6 py-5 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500/40"
                >
                  <span className="font-sora font-semibold text-base text-zinc-900">
                    {item.question}
                  </span>
                  <i
                    className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-emerald-600 text-lg shrink-0`}
                    aria-hidden="true"
                  />
                </button>
                {isOpen && (
                  <div
                    id={panelId}
                    role="region"
                    aria-labelledby={buttonId}
                    className="px-6 pb-5"
                  >
                    <p className="font-inter text-zinc-500 text-sm leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
